import update from 'immutability-helper';
import ActionTypes from 'constants/ActionTypes';

const initialState = {
    actions: {
        visibleId: null,
    },
    help: {
        visibility: false,
    },
    user: {
        visibility: false,
    },
};

const dropdownsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.UI_DROPDOWNS_HELP_CLOSE: {
            return update(state, {
                help: {
                    visibility: {
                        $set: false,
                    },
                },
            });
        }
        case ActionTypes.UI_DROPDOWNS_HELP_SHOW: {
            return update(state, {
                help: {
                    visibility: {
                        $set: true,
                    },
                },
            });
        }

        case ActionTypes.UI_DROPDOWNS_ACTIONS_SHOW: {
            return update(state, {
                actions: {
                    visibleId: {
                        $set: action.payload,
                    },
                },
            });
        }
        case ActionTypes.UI_DROPDOWNS_ACTIONS_CLOSE: {
            return update(state, {
                actions: {
                    visibleId: {
                        $set: null,
                    },
                },
            });
        }
        case ActionTypes.UI_ALL_CLOSE: {
            return initialState;
        }
        default: {
            return state;
        }
    }
};

export default dropdownsReducer;
